module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    attrs: {
      "color": _vm.color,
      "dismissible": "",
      "value": true
    },
    on: {
      "input": _vm.onClose
    }
  }, [(_vm.type === 'html') ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-108e492d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = 944
// module chunks = 19 27 31 33 34 35 37